import { postDataJson } from "../api";

function NoticeList(param) {
    return postDataJson("/api/Notice/NoticeList", { param: param });
}
export default {
    NoticeList,
};